/**
 * Limpeza de caches do navegador relacionados ao app (deploy / assets antigos).
 * Não altera localStorage — sessão permanece com AuthContext.
 */

export type ClearCachesResult = {
  cacheEntriesDeleted: number;
  serviceWorkersUnregistered: number;
};

function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

/** Remove todas as chaves do Cache Storage (PWA, Workbox, caches manuais). */
export async function clearServiceWorkerCaches(): Promise<number> {
  if (!isBrowser() || !('caches' in window)) return 0;
  try {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
    return keys.length;
  } catch (e) {
    console.error('[techforms] Falha ao limpar Cache Storage:', e);
    return 0;
  }
}

/** Desregistra service workers para não servir bundle antigo após novo deploy. */
export async function unregisterAllServiceWorkers(): Promise<number> {
  if (!isBrowser() || !('serviceWorker' in navigator)) return 0;
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((reg) => reg.unregister()));
    return registrations.length;
  } catch (e) {
    console.error('[techforms] Falha ao desregistrar service workers:', e);
    return 0;
  }
}

/** Cache Storage + service workers em paralelo (uso ao montar login / páginas da área logada). */
export async function clearAppShellCaches(): Promise<ClearCachesResult> {
  const [cacheEntriesDeleted, serviceWorkersUnregistered] = await Promise.all([
    clearServiceWorkerCaches(),
    unregisterAllServiceWorkers(),
  ]);
  return { cacheEntriesDeleted, serviceWorkersUnregistered };
}
